export default __webpack_public_path__ + "static/mspartner-f859733b577efee9fa878ab43d74c64a.png";